import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer, Form, FormGroup,
    CustomContainer, FixedContainer, FlexRow, ScreenTitle 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from "src/provider/API/call-service";
import { NewCompanyLayout } from 'src/component'
import { useNotifier } from "react-pop-notifier"

export const NewCompanyLocation: React.FC<any> = ({fetchCompanies, back, close}) => {
    const {notifier} = useNotifier()
    const {API} = useContext(ApiContext)
    const {info: {companyCreationProcess}, setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState({
        address: '', state: '', 
        city: '',  country: '',
        password: '', confirmPassword: '',
    })

    useEffect(() => {
        if (companyCreationProcess) {
            const {address, state, city, country, password} = companyCreationProcess
            setInput({
                ...input, 
                address, 
                state, 
                city, 
                country,
                password
            }) 
        }
    }, [companyCreationProcess])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (input.password != input.confirmPassword) {
            return notifier.show('Password mismatch', 'Validation Response')
        }
    
        await setInfoProperty('companyCreationProcess', {...companyCreationProcess, ...input, locationAndPassword: true})

        const {name, firstName, lastName, email, phoneNumber, age, gender} = companyCreationProcess
        const payload = {
            firstName, lastName, email,
            phoneNumber, age, gender,
            name, ...input
        }
        
        const response = await API.createOrganization(payload)
        if (response) {
            fetchCompanies()
            close()
        }
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewCompanyLayout currentScreen='location-and-password'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Add company location and password
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='3' onSubmit={handleNext}>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>State</label>
                                <input 
                                    placeholder='Enter State' 
                                    name='state'
                                    value={input.state}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>City</label>
                                <input 
                                    placeholder='Enter City' 
                                    name='city'
                                    value={input.city}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Address</label>
                                <textarea 
                                    placeholder='Enter Address' 
                                    name='address'
                                    value={input.address}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Country</label>
                                <input 
                                    placeholder='Enter Country' 
                                    name='country'
                                    value={input.country}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Password</label>
                                <input 
                                    placeholder='Enter Password' 
                                    name='password'
                                    type='password'
                                    value={input.password}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Confirm Password</label>
                                <input 
                                    placeholder='Enter Password' 
                                    name='confirmPassword'
                                    type='password'
                                    value={input.confirmPassword}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>

                        <FlexRow 
                            justifyContent='flex-end'
                            gap="1" topMargin='5'
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={back}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Submit
                            </Button>
                        </FlexRow>
                    </Form>
                </NewCompanyLayout>
            </FixedContainer>
        </>
    )
}